import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { RawInput } from '../InputText/RawInput';
export var StyledOptions = styled.div(_templateObject(), function (props) {
  return "\n        border: 0;\n        background-color: ".concat(props.theme.components.select.backgroundColor, ";\n        position: absolute;\n        min-width: 100%;\n        box-shadow: 0 0 0px 1px ").concat(props.theme.components.input.boxShadowcolor, ";\n        z-index: ").concat(props.theme.components.select.belowSelectIndex, ";\n        overflow: auto;\n        max-height: ").concat(props.suggestLimit ? "".concat(props.suggestLimit * 48, "px") : 'unset', ";\n    ");
});
export var StyledSelectWrapper = styled.div(_templateObject2(), function (props) {
  return "\n        display: inline-block;\n        width: ".concat(props.fullWidth ? '100%' : 'auto', ";\n    ");
});
export var StyledSelect = styled.div(_templateObject3(), function (props) {
  return "\n        position: relative;\n        border-radius: ".concat(props.theme.components.select.borderRadius, ";\n        width: ").concat(props.fullWidth ? '100%' : 'auto', ";\n        cursor: ").concat(props.disabled ? 'default' : props.hasSuggest && 'default' || 'pointer', ";\n\n        ").concat(RawInput.Styles.StyledInput, " {\n            user-select: ").concat(props.hasSuggest ? 'initial' : 'none', ";\n            pointer-events: ").concat(props.hasSuggest ? 'initial' : 'none', ";\n            outline: none;\n        }\n    ");
});